import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "Header_Bar" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "Header_Menu" }
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  id: "usages-menu",
  class: "Header_Submenu"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "Header_MobileActions" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["aria-expanded", "aria-label"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = { class: "Header_MobileItem" }
const _hoisted_16 = { class: "Header_MobileItem Header_MobileItem--group" }
const _hoisted_17 = { class: "Header_MobileLink" }
const _hoisted_18 = { class: "Header_MobileSubmenu" }
const _hoisted_19 = { class: "Header_MobileItem" }

import translations from '@/dictionaries/navigation.json';
import logoUrl from '@/assets/img/logo-scene-pro-blanc.svg';
import chevronUrl from '@/assets/img/chevron-blanc.svg';
import hamburgerIconUrl from '@/assets/img/icon-hamburger-blanc.svg';
import closeIconUrl from '@/assets/img/icon-close-blanc.svg';
import HomeTickerComponent from '@/components/home/HomeTickerComponent.vue';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheHeaderComponent',
  setup(__props) {


const connectionUrl = process.env.VUE_APP_LOGIN_URL;
const route = useRoute();

// Every page shares the same gradient banner; only the title changes (set in route meta)
const pageTitle = computed(() => route.meta.pageTitle);

// Anchors of the sections of the "Usages" page
const usagesItems = [
  { hash: '#artistes-producteurs', label: translations.fr.usagesMenu.artistsProducers },
  { hash: '#diffuseurs', label: translations.fr.usagesMenu.presenters },
  { hash: '#reseaux', label: translations.fr.usagesMenu.networks },
  { hash: '#evenements-associations', label: translations.fr.usagesMenu.eventsAssociations },
  { hash: '#equipes-numeriques', label: translations.fr.usagesMenu.digitalTeams },
];

const dropdown = ref<HTMLElement | null>(null);
const isDropdownOpen = ref(false);
const isMobileMenuOpen = ref(false);
const desktopQuery = window.matchMedia('(min-width: 992px)');

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const closeDropdown = () => {
  isDropdownOpen.value = false;
};

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const closeMenus = () => {
  closeDropdown();
  isMobileMenuOpen.value = false;
};

const closeDropdownOnOutsideClick = (event: MouseEvent) => {
  if (dropdown.value && !dropdown.value.contains(event.target as Node)) {
    closeDropdown();
  }
};

const closeMobileMenuOnEscape = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    isMobileMenuOpen.value = false;
  }
};

watch(() => route.fullPath, closeMenus);

// The mobile menu covers the page, so the page behind must not scroll
watch(isMobileMenuOpen, (isOpen) => {
  document.body.style.overflow = isOpen ? 'hidden' : '';
});

onMounted(() => {
  document.addEventListener('click', closeDropdownOnOutsideClick);
  document.addEventListener('keydown', closeMobileMenuOnEscape);
  desktopQuery.addEventListener('change', closeMenus);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdownOnOutsideClick);
  document.removeEventListener('keydown', closeMobileMenuOnEscape);
  desktopQuery.removeEventListener('change', closeMenus);
  document.body.style.overflow = '';
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["Header", { 'Header--menuOpen': isMobileMenuOpen.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "Header_Brand"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(logoUrl),
            alt: _unref(translations).fr.logoAlt,
            class: "Header_Logo",
            width: "120",
            height: "65"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _createElementVNode("nav", {
        class: "Header_Nav",
        "aria-label": _unref(translations).fr.mainNavigation
      }, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/a-propos",
              class: "Header_MenuItem"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translations).fr.about), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            ref_key: "dropdown",
            ref: dropdown,
            class: "Header_Dropdown",
            onKeydown: _withKeys(closeDropdown, ["esc"])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "Header_MenuItem",
              "aria-haspopup": "true",
              "aria-controls": "usages-menu",
              "aria-expanded": isDropdownOpen.value,
              onClick: toggleDropdown
            }, [
              _createTextVNode(_toDisplayString(_unref(translations).fr.usages) + " ", 1),
              _createElementVNode("img", {
                src: _unref(chevronUrl),
                alt: "",
                class: "Header_Chevron",
                width: "16",
                height: "16"
              }, null, 8, _hoisted_6)
            ], 8, _hoisted_5),
            _withDirectives(_createElementVNode("ul", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(usagesItems, (item) => {
                return _createElementVNode("li", {
                  key: item.hash
                }, [
                  _createVNode(_component_router_link, {
                    to: { path: '/usages', hash: item.hash },
                    class: "Header_SubmenuItem"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              }), 64))
            ], 512), [
              [_vShow, isDropdownOpen.value]
            ])
          ], 544)
        ]),
        _createVNode(_component_router_link, {
          to: "/offres-de-spectacles",
          class: "Header_Btn Header_Btn--outline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translations).fr.showsDirectory), 1)
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          class: "Header_Btn Header_Btn--white",
          href: _unref(connectionUrl),
          target: "_blank"
        }, _toDisplayString(_unref(translations).fr.connexion), 9, _hoisted_8)
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          class: "Header_Btn Header_Btn--white",
          href: _unref(connectionUrl),
          target: "_blank"
        }, _toDisplayString(_unref(translations).fr.connexion), 9, _hoisted_10),
        _createElementVNode("button", {
          type: "button",
          class: "Header_MenuToggle",
          "aria-controls": "mobile-menu",
          "aria-expanded": isMobileMenuOpen.value,
          "aria-label": isMobileMenuOpen.value ? _unref(translations).fr.closeMenu : _unref(translations).fr.openMenu,
          onClick: toggleMobileMenu
        }, [
          (isMobileMenuOpen.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(closeIconUrl),
                alt: "",
                width: "11",
                height: "11"
              }, null, 8, _hoisted_12))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(hamburgerIconUrl),
                alt: "",
                width: "16",
                height: "10"
              }, null, 8, _hoisted_13))
        ], 8, _hoisted_11)
      ])
    ]),
    (pageTitle.value && !isMobileMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["Header_Hero", { 'Header_Hero--withTicker': _unref(route).meta.showTicker, 'Header_Hero--textPage': _unref(route).meta.textPage }])
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.pageTitleIsHeading === false ? 'p' : 'h1'), { class: "Header_Title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(pageTitle.value), 1)
            ]),
            _: 1
          }))
        ], 2))
      : _createCommentVNode("", true),
    (_unref(route).meta.showTicker && !isMobileMenuOpen.value)
      ? (_openBlock(), _createBlock(HomeTickerComponent, { key: 1 }))
      : _createCommentVNode("", true),
    (isMobileMenuOpen.value)
      ? (_openBlock(), _createElementBlock("nav", {
          key: 2,
          id: "mobile-menu",
          class: "Header_MobileMenu",
          "aria-label": _unref(translations).fr.mainNavigation
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/a-propos",
                class: "Header_MobileLink"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translations).fr.about), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(translations).fr.usages), 1),
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(usagesItems, (item) => {
                  return _createElementVNode("li", {
                    key: item.hash
                  }, [
                    _createVNode(_component_router_link, {
                      to: { path: '/usages', hash: item.hash },
                      class: "Header_MobileSublink"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: "/offres-de-spectacles",
                class: "Header_MobileLink"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translations).fr.showsDirectory), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 8, _hoisted_14))
      : _createCommentVNode("", true)
  ], 2))
}
}

})